import * as React from 'react';
import { DefaultButton, FontIcon, IDropdownOption, Label, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, TooltipHost } from '@fluentui/react';

import { useEffect, useState } from 'react';
import { IField, IColonnaGenerale, ITextField, IChoiceField } from '../../../shared/interfaces';
import DynamicForm from '../../DynamicForm/DynamicForm';
import { useBoolean } from '@fluentui/react-hooks';
import AppUtilities from '../../../shared/Utilities/appUtilities';
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import { RootState } from '../../../store';
import { connect, ConnectedProps } from 'react-redux';
import { DataType, DataTypeDropdownOptions, getLabelFromDataType, tryGetDataType } from '../../../shared/enums';



const optionsDataType: IDropdownOption[] = DataTypeDropdownOptions();

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface AddEditCustomColumnsManagerProps {
    loading?: boolean
    extraCssClass?: string
    selectedColonnaGenerale?: Partial<IColonnaGenerale>
    panelHeaderText: string
    panelIsOpen: boolean
    onSubmit: (colonnaGeneraleManagerItem: Partial<IColonnaGenerale>) => void
    onDismiss: () => void
    panelIsReadOnlyMode: boolean
}

type Props = AddEditCustomColumnsManagerProps & PropsFromRedux

const AddEditCustomColumnsManager: React.FunctionComponent<Props> = (props) => {
    let loading = props.loading !== undefined ? props.loading : false;

    const [panelIsOpen, setPanelIsOpen] = useState<boolean>(props.panelIsOpen);
    const [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);
    const [messageBarType, setMessageBarType] = useState<MessageBarType>();
    const [messageBarText, setMessageBarText] = useState<string>('');
    const [fields, setFields] = useState<IField[]>([]);
    const [configurationFields, setConfigurationFields] = useState<IField[]>([]);


    useEffect(() => {

        resetFields();
        dismissMessageBar();
        setPanelIsOpen(props.panelIsOpen);

    }, [props.panelIsOpen]);


    useEffect(() => {

        resetFields();

    }, [props.panelIsReadOnlyMode, props.selectedColonnaGenerale, props.panelIsOpen]);


    const resetFields = () => {
        let displayNameValue;
        let typeValue;
        let requiredValue;
        let readonlyValue = false;
        let systemValue = false;

        let isTypeFieldReadonly = false;
        let isReadOnlyMode = props.panelIsReadOnlyMode;
        if (props.selectedColonnaGenerale) {
            let colonnaGeneraleSelezionata = props.selectedColonnaGenerale as IColonnaGenerale;
            displayNameValue = colonnaGeneraleSelezionata.displayName;
            typeValue = getLabelFromDataType(colonnaGeneraleSelezionata.type);
            requiredValue = colonnaGeneraleSelezionata.required;
            readonlyValue = colonnaGeneraleSelezionata.readOnly;
            systemValue = colonnaGeneraleSelezionata.system;
            isTypeFieldReadonly = true;
        }


        let newFields = [
            {
                displayName: "Nome",
                internalName: "displayName",
                controlType: "textbox",
                required: true,
                readonly: isReadOnlyMode,
                disabled: false,
                system: false,
                internalValue: displayNameValue,
                touched: false
            } as ITextField,

            {
                displayName: "Tipo",
                internalName: "type",
                controlType: "dropdown",
                required: true,
                readonly: isTypeFieldReadonly, // non è possibile modificare il tipo di colonna
                disabled: false,
                system: false,
                internalValue: typeValue,
                valid: false,
                touched: false,
                options: [...optionsDataType]
            } as IChoiceField,

            {
                displayName: "Obbligatorio",
                internalName: "required",
                controlType: "boolean",
                required: true,
                readonly: isReadOnlyMode,
                disabled: false,
                system: false,
                internalValue: requiredValue,
                touched: false
            } as IField,

            {
                displayName: "Sistema",
                internalName: "system",
                controlType: "boolean",
                required: false,
                readonly: true,
                disabled: false,
                system: false,
                internalValue: systemValue,
                touched: false
            } as IField,

            {
                displayName: "Sola lettura",
                internalName: "readOnly",
                controlType: "boolean",
                required: false,
                readonly: true,
                disabled: false,
                system: false,
                internalValue: readonlyValue,
                touched: false

            } as IField,

        ];
        if (props.selectedColonnaGenerale) {
            let colonnaGeneraleSelezionata = props.selectedColonnaGenerale as IColonnaGenerale;
            newFields = [...updateConfigurationFieldsByType(colonnaGeneraleSelezionata.type, newFields)];
        }

        setFields(newFields);


    }

    const updateConfigurationFieldsByType = (selectedType: DataType, currentFields: IField[]): IField[] => {
        // Rimuovi tutti i campi dinamici gestiti
        let newFields = currentFields.filter(
            f =>
                f.internalName !== 'DateOnly' &&
                f.internalName !== 'Decimals' &&
                f.internalName !== 'Multi' &&
                f.internalName !== 'Options'
        );
        let configurations: any = {};
        if (props.selectedColonnaGenerale) {
            let colonnaGeneraleSelezionata = props.selectedColonnaGenerale;
            configurations = colonnaGeneraleSelezionata.configuration;
        }
        let isReadOnlyMode = props.panelIsReadOnlyMode;

        switch (selectedType) {
            case DataType.DateTime:

                newFields.push({
                    displayName: "Solo data",
                    internalName: "DateOnly",
                    controlType: "boolean",
                    required: true,
                    readonly: isReadOnlyMode,
                    disabled: false,
                    system: false,
                    internalValue: configurations.DateOnly,
                    touched: false
                } as IField);
                break;

            case DataType.Number:
            case DataType.Currency:
                newFields.push({
                    displayName: "Numero di cifre decimali",
                    internalName: "Decimals",
                    controlType: "dropdown",
                    required: true,
                    readonly: isReadOnlyMode,
                    disabled: false,
                    system: false,
                    internalValue: configurations.Decimals,
                    touched: false,
                    options: [
                        { key: 0, text: 0 },
                        { key: 1, text: 1 },
                        { key: 2, text: 2 },
                        { key: 3, text: 3 },
                        { key: 4, text: 4 },
                        { key: 5, text: 5 },
                    ]
                } as IChoiceField);
                break;

            case DataType.User:
                newFields.push({
                    displayName: "Selezione multipla",
                    internalName: "Multi",
                    controlType: "boolean",
                    required: true,
                    readonly: isReadOnlyMode,
                    disabled: false,
                    system: false,
                    internalValue: configurations.Multi,
                    touched: false
                } as IField);
                break;
            case DataType.Choice:
                let options = configurations.Options ? isReadOnlyMode ? configurations.Options.join('; ') :configurations.Options.join('\n') : null;
                newFields.push({
                    displayName: "Opzioni di scelta",
                    internalName: "Options",
                    controlType: "textarea",
                    required: true,
                    readonly: isReadOnlyMode,
                    disabled: false,
                    system: false,
                    internalValue: options,
                    touched: false,
                    customLabel: <Label className='field-label' htmlFor='Options' required={true}>
                        Opzioni di scelta <TooltipHost content='Digitare ogni scelta in una riga distinta' id={`tooltip_Options`}> <FontIcon aria-label="Info" iconName="Info" /></TooltipHost>
                    </Label>
                } as IField);
                break;
        }

        return newFields;
    };

    //// Click su salva del panel laterale
    const addEditCustomColumnsManagerPanelSubmit = () => {
        let _configuration: any = {};
        _configuration.DateOnly = fields.find(el => el.internalName === 'DateOnly')?.internalValue ?? false;
        _configuration.Decimals = fields.find(el => el.internalName === 'Decimals')?.internalValue;
        _configuration.Multi = fields.find(el => el.internalName === 'Multi')?.internalValue ?? false;
        let options = fields.find(el => el.internalName === 'Options')?.internalValue;
        if (options != null && options.trim() !== '')
            _configuration.Options = options.trim().split("\n").filter(e => e !== '');

        let typeFieldRaw = fields.find(el => el.internalName === 'type')?.internalValue;
        let typeFieldValue = tryGetDataType(typeFieldRaw);


        if (checkColonnaGeneraleManagerFormValidity()) {
            let colonnaGeneraleItem: Partial<IColonnaGenerale> = {
                id: props.selectedColonnaGenerale?.id,
                displayName: fields.find(el => el.internalName === 'displayName')?.internalValue,
                type: typeFieldValue,
                required: fields.find(el => el.internalName === 'required')?.internalValue ?? false,
                readOnly: fields.find(el => el.internalName === 'readOnly')?.internalValue ?? false,
                configuration: _configuration
            };

            props.onSubmit(colonnaGeneraleItem);
            resetFormFields();
        }
    }

    const resetFormFields = () => {

        let newFields = fields.map(el => {
            return { ...el, internalValue: null, touched: false, valid: true };
        });
        setFields(newFields);
    }

    const checkColonnaGeneraleManagerFormValidity = (): boolean => {

        let isValid = true;

        const updatedFields = fields.map((item, index) => {
            let fieldValidity = AppUtilities.checkFieldValidity(item);
            if (!fieldValidity)
                isValid = false;

            return {
                ...item,
                touched: true,
                valid: fieldValidity
            }
        });
        setFields(updatedFields);
        if (isValid) {
            dismissMessageBar();
        }
        else {
            setMessageBarText('Compilare correttamente i campi');
            setMessageBarType(MessageBarType.error);
            showMessageBar();
        }

        return isValid;
    }


    const inputChangedHandler = (newField: IField) => {
        let updatedFields = [...fields];
        let itemIndex = updatedFields.findIndex(el => el.internalName === newField.internalName);
        updatedFields[itemIndex] = { ...newField };

        // Se cambia il tipo, aggiorna i campi dinamici
        if (newField.internalName === 'type') {
            updatedFields = updateConfigurationFieldsByType(newField.internalValue as DataType, updatedFields);
        }

        setFields(updatedFields);
    };

    const onRenderLateralPanelFooterContent = () => {
        if(props.panelIsReadOnlyMode)
            return null;
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Salva"
                    onClick={addEditCustomColumnsManagerPanelSubmit}
                />
                <DefaultButton
                    onClick={props.onDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <Panel
                key='addEditCustomColumnsManagerPanel'
                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={props.panelHeaderText}
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={props.onDismiss}
                onRenderFooterContent={onRenderLateralPanelFooterContent}
                isFooterAtBottom={false}
            >
                {messageBarIsVisible &&
                    <MessageBar
                        messageBarType={messageBarType}
                        isMultiline={false}
                        onDismiss={dismissMessageBar}
                        dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
                }

                <CircleLoader loaderClass='loader-large' loading={loading} />




                <div className={"flex flex-column position-relative overflow-hidden"}>

                    <div className={`position-relative my-scroll-div overflowX-hidden`}>

                        <DynamicForm
                            fields={[...fields, ...configurationFields]} 
                            onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
                        />
                    </div>
                </div>
            </Panel>

        </React.Fragment>

    );
}

export default connector(AddEditCustomColumnsManager);